import { UseCases } from "@planzone/core";
import {
  event,
  Identifiable,
  milestone,
  Project,
  Task,
  task,
  OptimizedGantt,
  project as projectMock,
} from "@planzone/dto";
import { useModal } from "@root/client/modal";
import { usePermissions } from "@scenes/safeguard";
import { isEvent, isList, isMilestone, isProject, isTask } from "../utils";

function useViewElement(
  element: OptimizedGantt[number],
  project?: Identifiable<Project>,
) {
  const { pushView } = useModal();
  const { canEditProject } = usePermissions([UseCases.editProject]);
  const isMultiProject = !project;

  return () =>
    isTask(element)
      ? pushView({
          key: UseCases.retrieveTask,
          data: {
            task: { ...task, ...element },
            isMultiProject,
          },
        })
      : isEvent(element)
        ? pushView({
            key: UseCases.retrieveEvent,
            data: {
              event: { ...event, ...element },
              isMultiProject,
            },
          })
        : isList(element)
          ? pushView({
              key: UseCases.retrieveList,
              data: { listId: element.uuid, isMultiProject },
            })
          : isMilestone(element)
            ? pushView({
                key: UseCases.retrieveMilestone,
                data: {
                  milestone: { ...milestone, ...element },
                  isMultiProject,
                },
              })
            : isProject(element) &&
              canEditProject &&
              pushView({
                key: UseCases.retrieveProject,
                data: {
                  project: {
                    ...(project || projectMock),
                    ...element,
                  } as Identifiable<Project>,
                  isMultiProject: true,
                },
              });
}

export { useViewElement };
